import React from 'react';

import { Button, ButtonProps, Menu } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { BigCommerceIcon } from 'icons/BigCommerceIcon';
import { ShopifyIcon } from 'icons/ShopifyIcon';
import { SquarespaceIcon } from 'icons/SquarespaceIcon';
import { WixIcon } from 'icons/WixIcon';
import { WooCommerceIcon } from 'icons/WooCommerceIcon';
import { useTranslation } from 'react-i18next';

type AddStoreButtonProps = ButtonProps;

export function AddStoreButton({ ...buttonProps }: AddStoreButtonProps) {
  const { t } = useTranslation();

  return (
    <Menu withinPortal position="bottom">
      <Menu.Target>
        <Button leftIcon={<IconPlus />} {...buttonProps}>
          {t('APP.ACTIONS.ADD')}
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          icon={<ShopifyIcon />}
          onClick={(event) => {
            event.stopPropagation();
            window.open('https://apps.shopify.com/droxy');
          }}>
          {t('STORES.OPTIONS.SHOPIFY')}
        </Menu.Item>
        <Menu.Divider />
        <Menu.Label>{t('APP.COMMING_SOON')}</Menu.Label>
        <Menu.Item
          disabled
          icon={<BigCommerceIcon disabled />}
          onClick={(event) => {
            event.stopPropagation();
          }}>
          {t('STORES.OPTIONS.BIGCOMMERCE')}
        </Menu.Item>
        <Menu.Item
          disabled
          icon={<WixIcon disabled />}
          onClick={(event) => {
            event.stopPropagation();
          }}>
          {t('STORES.OPTIONS.WIX')}
        </Menu.Item>
        <Menu.Item
          disabled
          icon={<WooCommerceIcon disabled />}
          onClick={(event) => {
            event.stopPropagation();
          }}>
          {t('STORES.OPTIONS.WOOCOMMERCE')}
        </Menu.Item>
        <Menu.Item
          disabled
          icon={<SquarespaceIcon disabled />}
          onClick={(event) => {
            event.stopPropagation();
          }}>
          {t('STORES.OPTIONS.SQUARESPACE')}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
